package com.evoapps.evoshift.ui.finance

import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.filedrop.FileDropArea
import com.evoapps.evoshift.filedrop.FileDropTags
import com.evoapps.evoshift.spreadsheet.spreadsheetDropSpec
import com.evoapps.evoshift.viewmodels.PickedSalesFile
import evoshift.composeapp.generated.resources.sales_import_drop
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.LinkOff
import androidx.compose.material.icons.filled.PointOfSale
import androidx.compose.material.icons.filled.UploadFile
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.model.PosIntegration
import com.evoapps.evoshift.domain.model.PosSyncStatus
import com.evoapps.evoshift.domain.salesimport.SalesColumnMapping
import com.evoapps.evoshift.domain.salesimport.SalesRowIssue
import com.evoapps.evoshift.domain.salesimport.SalesRowProblem
import com.evoapps.evoshift.domain.usecase.finance.SalesImportAction
import com.evoapps.evoshift.domain.usecase.finance.SalesImportLine
import com.evoapps.evoshift.salesimport.rememberSalesFilePicker
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.adaptive.FormMaxWidth
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.ui.util.dayAndDate
import com.evoapps.evoshift.viewmodels.Gate
import com.evoapps.evoshift.viewmodels.SalesImportUiState
import com.evoapps.evoshift.viewmodels.SalesImportViewModel
import com.evoapps.evoshift.viewmodels.shows
import com.evoapps.evoshift.widgets.DataRow
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.GoldButton
import com.evoapps.evoshift.widgets.RegularCard
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.cancel
import evoshift.composeapp.generated.resources.pos_api_key
import evoshift.composeapp.generated.resources.pos_connect
import evoshift.composeapp.generated.resources.pos_disconnect
import evoshift.composeapp.generated.resources.pos_disconnect_confirm
import evoshift.composeapp.generated.resources.pos_intro
import evoshift.composeapp.generated.resources.pos_last_sync
import evoshift.composeapp.generated.resources.pos_last_sync_failed
import evoshift.composeapp.generated.resources.pos_last_sync_key
import evoshift.composeapp.generated.resources.pos_last_sync_ok
import evoshift.composeapp.generated.resources.pos_never
import evoshift.composeapp.generated.resources.pos_schedule
import evoshift.composeapp.generated.resources.pos_status_connected
import evoshift.composeapp.generated.resources.pos_steps
import evoshift.composeapp.generated.resources.pos_sync_now
import evoshift.composeapp.generated.resources.pos_title
import evoshift.composeapp.generated.resources.pos_vat
import evoshift.composeapp.generated.resources.pos_vat_hint
import evoshift.composeapp.generated.resources.pos_vat_used
import evoshift.composeapp.generated.resources.sales_import_action_closed
import evoshift.composeapp.generated.resources.sales_import_action_import
import evoshift.composeapp.generated.resources.sales_import_action_manual
import evoshift.composeapp.generated.resources.sales_import_action_replace
import evoshift.composeapp.generated.resources.sales_import_action_unchanged
import evoshift.composeapp.generated.resources.sales_import_apply
import evoshift.composeapp.generated.resources.sales_import_choose_file
import evoshift.composeapp.generated.resources.sales_import_column_date
import evoshift.composeapp.generated.resources.sales_import_column_gross
import evoshift.composeapp.generated.resources.sales_import_column_net
import evoshift.composeapp.generated.resources.sales_import_column_none
import evoshift.composeapp.generated.resources.sales_import_column_position
import evoshift.composeapp.generated.resources.sales_import_count_closed
import evoshift.composeapp.generated.resources.sales_import_count_import
import evoshift.composeapp.generated.resources.sales_import_count_manual
import evoshift.composeapp.generated.resources.sales_import_count_unchanged
import evoshift.composeapp.generated.resources.sales_import_file_hint
import evoshift.composeapp.generated.resources.sales_import_file_title
import evoshift.composeapp.generated.resources.sales_import_intro
import evoshift.composeapp.generated.resources.sales_import_issue_row
import evoshift.composeapp.generated.resources.sales_import_issues
import evoshift.composeapp.generated.resources.sales_import_issues_more
import evoshift.composeapp.generated.resources.sales_import_nothing
import evoshift.composeapp.generated.resources.sales_import_problem_date
import evoshift.composeapp.generated.resources.sales_import_problem_gross
import evoshift.composeapp.generated.resources.sales_import_problem_negative
import evoshift.composeapp.generated.resources.sales_import_problem_net
import evoshift.composeapp.generated.resources.sales_import_read_only
import evoshift.composeapp.generated.resources.sales_import_reading
import evoshift.composeapp.generated.resources.sales_import_title
import org.jetbrains.compose.resources.stringResource
import com.evoapps.evoshift.ui.util.monthName
import evoshift.composeapp.generated.resources.sales_import_month_only
import kotlinx.datetime.number

/** Test tags of the Sales import screen. */
object SalesImportTags {
    const val CHOOSE_FILE = "sales_import_choose_file"
    const val APPLY = "sales_import_apply"
    const val API_KEY = "pos_api_key"
    const val VAT = "pos_vat"
    const val CONNECT = "pos_connect"
    const val SYNC = "pos_sync_now"
    const val DISCONNECT = "pos_disconnect"
}

/**
 * SH-123: Sales import (More → Sales import), owners and financial managers. A CSV/XLSX file of
 * daily net sales: its columns as found, a preview of what each day becomes (takings typed by
 * hand and closed days are kept), the rows left out, then "Import N days". Below it the till:
 * connecting SumUp with an API key (sent once to the server, kept in Secret Manager), the last
 * daily import, "Import now" and "Disconnect".
 */
@Composable
fun SalesImportScreen(viewModel: SalesImportViewModel, onNavigateBack: () -> Unit) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val snackbarHostState = remember { SnackbarHostState() }
    val picker = rememberSalesFilePicker(viewModel::onFilePicked)
    var confirmDisconnect by rememberSaveable { mutableStateOf(false) }

    val messageText = state.message?.asString()
    LaunchedEffect(messageText) {
        messageText?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.messageShown()
        }
    }

    Scaffold(
        containerColor = Cream,
        snackbarHost = { SnackbarHost(snackbarHostState) },
        topBar = { EvoTopBar(title = stringResource(Res.string.sales_import_title), onBack = onNavigateBack, showWorkplace = true) }
    ) { padding ->
        LazyColumn(
            modifier = Modifier.fillMaxSize().contentWidth(FormMaxWidth).padding(padding),
            contentPadding = PaddingValues(16.dp),
            verticalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            item("intro") {
                Text(stringResource(Res.string.sales_import_intro), style = MaterialTheme.typography.bodyMedium, color = DeepNavy.copy(alpha = 0.75f))
            }
            if (state.capabilities.shows(Gate.MONEY) && !state.canEdit) {
                item("read_only") { Text(stringResource(Res.string.sales_import_read_only), color = DeepNavy.copy(alpha = 0.6f)) }
            }
            item("file") {
                // SH-233: a sales file dropped on the card (web, desktop, Android and ChromeOS) goes the chooser's way.
                FileDropArea(
                    spec = spreadsheetDropSpec,
                    dropLabel = stringResource(Res.string.sales_import_drop),
                    onFile = { file -> viewModel.onFilePicked(file?.let { PickedSalesFile(it.name, it.bytes) }) },
                    enabled = state.canEdit && !state.isReading,
                    snackbarHostState = snackbarHostState,
                    tag = FileDropTags.SALES
                ) {
                    FileCard(state, onChoose = picker::pick, onApply = viewModel::applyImport, onCancel = viewModel::clearFile)
                }
            }
            val plan = state.plan
            if (plan != null && state.sheet != null) {
                item("days") { DaysCard(plan.lines, state.currency) }
            }
            item("till") {
                TillCard(
                    state = state,
                    onConnect = viewModel::connect,
                    onSync = viewModel::syncNow,
                    onDisconnect = { confirmDisconnect = true }
                )
            }
        }
    }

    if (confirmDisconnect) {
        EvoDialog(
            title = stringResource(Res.string.pos_disconnect),
            subtitle = stringResource(Res.string.pos_disconnect_confirm),
            onDismiss = { confirmDisconnect = false },
            destructive = true,
            confirm = DialogAction(stringResource(Res.string.pos_disconnect), {
                confirmDisconnect = false
                viewModel.disconnect()
            })
        ) {}
    }
}

@Composable
private fun SectionTitle(text: String, icon: androidx.compose.ui.graphics.vector.ImageVector) {
    Row(verticalAlignment = Alignment.CenterVertically) {
        Icon(icon, contentDescription = null, tint = DeepNavy, modifier = Modifier.size(22.dp))
        Text(text, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, color = DeepNavy, modifier = Modifier.padding(start = 8.dp))
    }
}

@Composable
private fun FileCard(state: SalesImportUiState, onChoose: () -> Unit, onApply: () -> Unit, onCancel: () -> Unit) {
    RegularCard(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
            SectionTitle(stringResource(Res.string.sales_import_file_title), Icons.Default.UploadFile)
            Text(stringResource(Res.string.sales_import_file_hint), style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.7f))
            val sheet = state.sheet
            val plan = state.plan
            when {
                state.isReading -> Row(verticalAlignment = Alignment.CenterVertically) {
                    CircularProgressIndicator(Modifier.size(20.dp), strokeWidth = 2.dp, color = DeepNavy)
                    Text(stringResource(Res.string.sales_import_reading), modifier = Modifier.padding(start = 12.dp))
                }
                sheet != null && plan != null -> {
                    state.fileName?.let { Text(it, fontWeight = FontWeight.Bold, color = DeepNavy) }
                    // SH-161 F4: a file opened with the app, for the month the person picked.
                    state.month?.let { month ->
                        Text(
                            stringResource(Res.string.sales_import_month_only, "${monthName(month.month.number)} ${month.year}"),
                            style = MaterialTheme.typography.bodySmall,
                            color = DeepNavy.copy(alpha = 0.7f)
                        )
                    }
                    ColumnsFound(sheet.mapping)
                    HorizontalDivider(color = DeepNavy.copy(alpha = 0.08f))
                    DataRow(stringResource(Res.string.sales_import_count_import), plan.toWrite.toString())
                    DataRow(stringResource(Res.string.sales_import_count_manual), plan.count(SalesImportAction.KEEP_MANUAL).toString())
                    DataRow(stringResource(Res.string.sales_import_count_closed), plan.count(SalesImportAction.DAY_CLOSED).toString())
                    DataRow(stringResource(Res.string.sales_import_count_unchanged), plan.count(SalesImportAction.UNCHANGED).toString())
                    if (sheet.issues.isNotEmpty()) Issues(sheet.issues)
                    if (state.canEdit) {
                        if (plan.toWrite == 0) {
                            Text(stringResource(Res.string.sales_import_nothing), color = DeepNavy.copy(alpha = 0.6f))
                        } else {
                            GoldButton(
                                text = stringResource(Res.string.sales_import_apply, plan.toWrite),
                                onClick = onApply,
                                isBusy = state.isApplying,
                                modifier = Modifier.fillMaxWidth().testTag(SalesImportTags.APPLY)
                            )
                        }
                    }
                    TextButton(onClick = onCancel, modifier = Modifier.align(Alignment.End)) { Text(stringResource(Res.string.cancel), color = DeepNavy) }
                }
                state.canEdit -> OutlinedButton(onClick = onChoose, modifier = Modifier.fillMaxWidth().testTag(SalesImportTags.CHOOSE_FILE)) {
                    Text(stringResource(Res.string.sales_import_choose_file), color = DeepNavy)
                }
            }
        }
    }
}

@Composable
private fun ColumnsFound(mapping: SalesColumnMapping) {
    @Composable
    fun column(header: String?, index: Int?): String = when {
        index == null -> stringResource(Res.string.sales_import_column_none)
        !header.isNullOrBlank() -> header
        else -> stringResource(Res.string.sales_import_column_position, columnLetter(index))
    }
    Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
        Text(stringResource(Res.string.sales_import_column_date, column(mapping.dateHeader, mapping.dateColumn)), style = MaterialTheme.typography.bodySmall)
        Text(stringResource(Res.string.sales_import_column_net, column(mapping.netHeader, mapping.netColumn)), style = MaterialTheme.typography.bodySmall)
        Text(stringResource(Res.string.sales_import_column_gross, column(mapping.grossHeader, mapping.grossColumn)), style = MaterialTheme.typography.bodySmall)
    }
}

/** 0 → "A", 27 → "AB". */
internal fun columnLetter(index: Int): String {
    var n = index + 1
    val letters = StringBuilder()
    while (n > 0) {
        val rem = (n - 1) % 26
        letters.insert(0, 'A' + rem)
        n = (n - 1) / 26
    }
    return letters.toString()
}

private const val ISSUES_SHOWN = 5

@Composable
private fun Issues(issues: List<SalesRowIssue>) {
    Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
        Text(stringResource(Res.string.sales_import_issues, issues.size), fontWeight = FontWeight.Bold, color = DeepNavy)
        issues.take(ISSUES_SHOWN).forEach { issue ->
            val problem = stringResource(
                when (issue.problem) {
                    SalesRowProblem.DATE -> Res.string.sales_import_problem_date
                    SalesRowProblem.NET_AMOUNT -> Res.string.sales_import_problem_net
                    SalesRowProblem.GROSS_AMOUNT -> Res.string.sales_import_problem_gross
                    SalesRowProblem.NEGATIVE -> Res.string.sales_import_problem_negative
                }
            )
            Text(stringResource(Res.string.sales_import_issue_row, issue.row, problem, issue.value), style = MaterialTheme.typography.bodySmall)
        }
        if (issues.size > ISSUES_SHOWN) {
            Text(stringResource(Res.string.sales_import_issues_more, issues.size - ISSUES_SHOWN), style = MaterialTheme.typography.bodySmall)
        }
    }
}

@Composable
private fun DaysCard(lines: List<SalesImportLine>, currency: String) {
    RegularCard(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            lines.forEachIndexed { index, line ->
                if (index > 0) HorizontalDivider(color = DeepNavy.copy(alpha = 0.06f))
                Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                    Column(Modifier.weight(1f)) {
                        Text("${dayAndDate(line.day.date)} ${line.day.date.year}", fontWeight = FontWeight.Medium, color = DeepNavy)
                        Text(
                            stringResource(
                                when (line.action) {
                                    SalesImportAction.IMPORT -> Res.string.sales_import_action_import
                                    SalesImportAction.REPLACE_IMPORT -> Res.string.sales_import_action_replace
                                    SalesImportAction.UNCHANGED -> Res.string.sales_import_action_unchanged
                                    SalesImportAction.KEEP_MANUAL -> Res.string.sales_import_action_manual
                                    SalesImportAction.DAY_CLOSED -> Res.string.sales_import_action_closed
                                }
                            ),
                            style = MaterialTheme.typography.bodySmall,
                            color = DeepNavy.copy(alpha = if (line.action.writes) 0.8f else 0.5f)
                        )
                    }
                    Column(horizontalAlignment = Alignment.End) {
                        Text(formatMoney(line.day.net, currency), fontWeight = FontWeight.Bold, color = DeepNavy)
                        line.currentNetto?.takeIf { !line.action.writes || line.action == SalesImportAction.REPLACE_IMPORT }?.let {
                            Text(formatMoney(it, currency), style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.5f))
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun TillCard(
    state: SalesImportUiState,
    onConnect: (String, Double) -> Unit,
    onSync: () -> Unit,
    onDisconnect: () -> Unit
) {
    RegularCard(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
            SectionTitle(stringResource(Res.string.pos_title), Icons.Default.PointOfSale)
            Text(stringResource(Res.string.pos_intro), style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.7f))
            val integration = state.integration
            when {
                !state.integrationLoaded -> CircularProgressIndicator(Modifier.size(20.dp), strokeWidth = 2.dp, color = DeepNavy)
                integration != null -> Connected(integration, state, onSync, onDisconnect)
                state.canEdit -> ConnectForm(isConnecting = state.isConnecting, onConnect = onConnect)
            }
        }
    }
}

@Composable
private fun ConnectForm(isConnecting: Boolean, onConnect: (String, Double) -> Unit) {
    // The key lives only in this field until it is sent; it is not saved with the screen.
    var key by remember { mutableStateOf("") }
    var vat by rememberSaveable { mutableStateOf("8") }
    val vatValue = vat.replace(',', '.').toDoubleOrNull()?.takeIf { it in 0.0..30.0 }
    Text(stringResource(Res.string.pos_steps), style = MaterialTheme.typography.bodySmall, color = DeepNavy)
    EvoTextField(
        value = key,
        onValueChange = { key = it.trim() },
        label = stringResource(Res.string.pos_api_key),
        isPassword = true,
        modifier = Modifier.fillMaxWidth().testTag(SalesImportTags.API_KEY)
    )
    EvoTextField(
        value = vat,
        onValueChange = { vat = it },
        label = stringResource(Res.string.pos_vat),
        supportingText = stringResource(Res.string.pos_vat_hint),
        keyboardType = KeyboardType.Decimal,
        modifier = Modifier.fillMaxWidth().testTag(SalesImportTags.VAT)
    )
    GoldButton(
        text = stringResource(Res.string.pos_connect),
        onClick = { vatValue?.let { onConnect(key, it) } },
        enabled = key.isNotBlank() && vatValue != null,
        isBusy = isConnecting,
        modifier = Modifier.fillMaxWidth().testTag(SalesImportTags.CONNECT)
    )
}

@Composable
private fun Connected(integration: PosIntegration, state: SalesImportUiState, onSync: () -> Unit, onDisconnect: () -> Unit) {
    Text(stringResource(Res.string.pos_status_connected, integration.merchantCode), fontWeight = FontWeight.Bold, color = DeepNavy)
    DataRow(stringResource(Res.string.pos_vat_used), formatPercent(integration.vatRatePercent))
    val lastSync = integration.lastSyncAt?.take(16)?.replace('T', ' ')
    DataRow(
        stringResource(Res.string.pos_last_sync),
        when {
            lastSync == null -> stringResource(Res.string.pos_never)
            integration.lastSyncStatus == PosSyncStatus.KEY_REJECTED -> stringResource(Res.string.pos_last_sync_key, lastSync)
            integration.lastSyncStatus == PosSyncStatus.FAILED -> stringResource(Res.string.pos_last_sync_failed, lastSync)
            else -> stringResource(Res.string.pos_last_sync_ok, lastSync, integration.lastSync?.written ?: 0)
        }
    )
    Text(stringResource(Res.string.pos_schedule), style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.6f))
    if (state.canEdit) {
        Spacer(Modifier.height(4.dp))
        GoldButton(
            text = stringResource(Res.string.pos_sync_now),
            onClick = onSync,
            isBusy = state.isSyncing,
            modifier = Modifier.fillMaxWidth().testTag(SalesImportTags.SYNC)
        )
        OutlinedButton(onClick = onDisconnect, modifier = Modifier.fillMaxWidth().testTag(SalesImportTags.DISCONNECT)) {
            Icon(Icons.Default.LinkOff, contentDescription = null, tint = DeepNavy, modifier = Modifier.size(18.dp))
            Text(stringResource(Res.string.pos_disconnect), color = DeepNavy, modifier = Modifier.padding(start = 8.dp))
        }
    }
}
